import React, { Component } from 'react';
import StepperEvent from '../../../Components/StepperEvent';
// import Table from '../../../Components/Table';
import { Card, CardBody, Row, Col } from 'reactstrap';
import TablesEvent from './tablesEvent';

// import './styles.css';

class Coments extends Component {
  state = {
    allSteps: [],
    allTables: [],
    steps: [
      {
        label: 'Booking Request',
        value: '',
        id: 1,
        completed: false,
        order: 1,
        middleStep: ''
      },
      {
        label: 'Booking Confirmation',
        value: '',
        id: 2,
        completed: false,
        order: 2,
        idStep: '',
        middleStep: ''
      },
      {
        label: 'ATD',
        value: '',
        id: 7,
        completed: false,
        order: 3,
        middle: false,
        idStep: '',
        middleStep: ''
      },
      {
        label: 'ATA',
        value: '',
        id: 9,
        completed: false,
        order: 4,
        idStep: 'step4',
        middleStep: ''
      },
      {
        label: 'Docs Release',
        value: '',
        id: 10,
        completed: false,
        order: 5,
        idStep: 'step5',
        middleStep: ''
      },
      {
        label: `Delivery at Destination `,
        value: '',
        id: 11,
        completed: false,
        order: 6,
        idStep: 'step6',
        middleStep: ''
      }
    ],
    columns: [
      { label: 'Event Description', key: 'EventDescription', idTh: 'firstTh', idTd: 'firstTd' },
      { label: 'Event Date', key: 'EventDate', idTh: 'firstTh', idTd: 'firstTd' },
      { label: 'Category Responsible', key: 'CategoryResponsable', idTh: 'firstTh', idTd: 'firstTd' },
      { label: 'Name', key: 'Origin', idTh: 'firstTh', idTd: 'firstTd' },
      { label: 'Update Date', key: 'CreateDate', idTh: 'firstTh', idTd: 'firstTd' },
    ],
    tables: [
      {
        columns: [
          { label: 'Event Description', key: 'Descripcion', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Event Date', key: 'Fecha', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Category Responsible', key: 'Categoria', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Name', key: 'Nombre', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Update Date', key: 'FechaActualizacion', idTh: 'firstTh', idTd: 'firstTd' },
        ],
        data: [
        ],
        title: 'Reserva'
      },
      {
        columns: [
          { label: 'Event Description', key: 'Descripcion', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Event Date', key: 'Fecha', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Category Responsible', key: 'Categoria', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Name', key: 'Nombre', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Update Date', key: 'FechaActualizacion', idTh: 'firstTh', idTd: 'firstTd' },
        ],
        data: [
        ],
        title: 'Embarques de Exportación'
      },
      {
        columns: [
          { label: 'Event Description', key: 'Descripcion', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Event Date', key: 'Fecha', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Category Responsible', key: 'Categoria', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Name', key: 'Nombre', idTh: 'firstTh', idTd: 'firstTd' },
          { label: 'Update Date', key: 'FechaActualizacion', idTh: 'firstTh', idTd: 'firstTd' },
        ],
        data: [
        ],
        title: 'Embarques de Importación'
      },
    ]
  }

  componentDidMount = () => {
    this.setState({
      steps: this.props.steps,
      allSteps: this.props.allSteps,
      HBL_HAWB: this.props.HBL_HAWB,
      DoEmbarque: this.props.DoEmbarque,
      Estatus: this.props.Estatus,
      logoUrl: this.props.logoUrl,
      cliente: this.props.cliente,
      NIT: this.props.NIT,
      Grupo: this.props.Grupo
    }, () => {
      this.createTables();
    });
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      steps: nextProps.steps,
      allSteps: nextProps.allSteps,
      HBL_HAWB: nextProps.HBL_HAWB,
      DoEmbarque: nextProps.DoEmbarque,
      Estatus: nextProps.Estatus,
      logoUrl: nextProps.logoUrl,
      cliente: nextProps.cliente,
      NIT: nextProps.NIT,
      Grupo: nextProps.Grupo
    }, () => { this.createTables(); });
  }

  createTables = () => {
    var allTables = [];
    this.state.allSteps.map((e) => {
      var findTable = false;
      allTables.map((f) => {
        if (f.eventType === e.EventType) {
          f.data.push(e);
          findTable = true;
        }
        return f;
      });
      if (!findTable) {
        var obj = {
          eventType: e.EventType,
          data: [e]
        };
        allTables.push(obj);
      }
      return e;
    });
    this.setState({ allTables: allTables });
  }

  render() {
    return (
      <>
        <Row>
          <Col xs={12}>
            <Card className="myCard">
              {/* <div className="row" style={{marginLeft: 15}}>
                <img alt="" src={this.state.logoUrl} width="50"></img>
                <div className="col">
                <strong style={{ color: '' }}>{cliente} ({NIT})  / {Grupo}</strong>
                <br/>
                  <strong style={{ color: '#0099ff' }}>{this.state.DoEmbarque}</strong>
                  <br/>
                  {this.state.HBL_HAWB}
                </div>
              </div>
              <div className="col-12">
                {this.state.Estatus}
              </div> */}
              <StepperEvent steps={this.state.steps} />
            </Card>
          </Col>
          <Col xs={12}>
            <Card className="myCard">
              <CardBody>
                {this.state.allTables.length > 0 ? <TablesEvent columns={this.state.columns} allTables={this.state.allTables} /> :

                  <h1 style={{ textAlign: 'center', marginTop: '2em', marginBottom:'2em' }}> No Results</h1>
                  // this.state.tables.map((e, key) => {
                  //   return (
                  //     <div key={key}>
                  //       <div className="col-12" key={key}>
                  //         <div className="row">
                  //           <div className="col-12">
                  //             <legend>{e.title}</legend>
                  //           </div>
                  //           <div className="col-12">
                  //             <div className="table_container">
                  //               < Table
                  //                 columns={e.columns} styleColumn={true} data={e.data} title={e.title}
                  //                 options={{
                  //                   styleColumn: true,
                  //                   large: false,
                  //                   downloads: {
                  //                     pdf: false,
                  //                     xlsx: false
                  //                   }
                  //                 }} />
                  //             </div>
                  //           </div>
                  //         </div>

                  //       </div>
                  //       <div style={{ height: 40 }}></div>
                  //     </div>
                  //   );
                  // })
                }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

export default Coments;
